import React from 'react';

import { Input, InputLabel, MenuItem, Pagination, Select, type SelectChangeEvent, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledContainer = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const StyledPagination = styled(Pagination)`
    margin-right: 2rem;
`;

const RowsPerPage = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 2rem;
`;

const StyledInputLabel = styled(InputLabel)`
    margin-right: 0.5rem;
`;

interface TablePaginationProps {
    count: number;
    rowsPerPage: number;
    page: number; /* Zero-based index */
    onPageChange: (event: unknown, newPage: number) => void;
    onRowsPerPageChange: (rowsPerPage: number) => void;
}

const TablePagination: React.FC<TablePaginationProps> = ({
    count,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange
}) => {
    const { t } = useTranslation('admin_settings');

    const pageCount = Math.ceil(count / rowsPerPage);

    const handleChange = (event: SelectChangeEvent<number>) => {
        onRowsPerPageChange(event.target.value as number);
    };

    return (
        <StyledContainer>
            <StyledPagination
                /* Converting from zero-based to one-based index */
                page={page}
                count={pageCount}
                color="primary"
                onChange={onPageChange}
                disabled={pageCount === 1}
            />
            <RowsPerPage>
                <StyledInputLabel id="rows-per-page-label">{t('users.rows-per-page')}</StyledInputLabel>
                <Select
                    value={rowsPerPage}
                    labelId="rows-per-page-label"
                    onChange={handleChange}
                    input={<Input disableUnderline value={rowsPerPage} />}
                >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                    <MenuItem value={1000}>1000</MenuItem>
                </Select>
            </RowsPerPage>
            <span>{t('users.total', { count })}</span>
        </StyledContainer>
    );
};

export { TablePagination };
